import React from "react";
import { Routes } from "../../app/route/RoutesConfig";
import XGSIcon from "../../ui-components/icon/xgsIcon";
import XGSIcons from "../../ui-components/icon/xgsIcons";

const NEW_CUSTOMER_URL = "https://www.xgsi.com/resources-overview/become-a-customer/";

const BENEFITS = [
  "View all open invoices",
  "Pay multiple invoices at once",
  "Access payment history",
  "Download invoices and receipts",
  "View shipment and billing information",
  "Manage account details",
  "Access reporting and self-service tools",
];

const PublicPayPortalPromo: React.FC = () => (
  <aside className="xgs-public-payment__portal">
    <h2 className="xgs-public-payment__portal-title">Need More Than a One-Time Payment?</h2>
    <p className="xgs-public-payment__portal-intro">
      Quick Pay is designed for fast invoice payments. For complete account management, sign in to
      the Customer Portal or create an account.
    </p>
    <ul className="xgs-public-payment__benefits">
      {BENEFITS.map((benefit) => (
        <li key={benefit}>
          <XGSIcon icon={XGSIcons.faCheck} className="xgs-public-payment__benefit-icon" />
          <span>{benefit}</span>
        </li>
      ))}
    </ul>
    <div className="xgs-public-payment__portal-actions">
      <div>
        <p className="xgs-public-payment__portal-prompt">Already have an account?</p>
        <a className="xgs-public-payment__portal-link xgs-public-payment__portal-link--primary" href="/">
          Login
        </a>
      </div>
      <div>
        <p className="xgs-public-payment__portal-prompt">XGS customer without portal access?</p>
        <a className="xgs-public-payment__portal-link" href={Routes.portalRegistration}>
          Request portal access
        </a>
      </div>
      <div>
        <p className="xgs-public-payment__portal-prompt">Not an XGS customer yet?</p>
        <a
          className="xgs-public-payment__portal-link"
          href={NEW_CUSTOMER_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Register as new customer
        </a>
      </div>
    </div>
  </aside>
);

export default PublicPayPortalPromo;
